import { connect } from 'react-redux';
import { getSiteId } from 'services/app/selectors';
import ChannelSelectModal from './ChannelSelectModal';

const mapStateToProps = state => ({
  siteId: getSiteId(state),
});

export default connect(mapStateToProps)(ChannelSelectModal);
